import type { Sensor } from '../api/models';

const sameVector3 = (
  a?: [number, number, number],
  b?: [number, number, number],
): boolean => Boolean(a && b && a[0] === b[0] && a[1] === b[1] && a[2] === b[2]);

export const hasAlignedPoseSnapshot = (sensor: Sensor): boolean =>
  Boolean(sensor.alignedPosition && sensor.alignedRotation);

export const alignedPoseDiffersFromLive = (sensor: Sensor): boolean =>
  hasAlignedPoseSnapshot(sensor) && (
    !sameVector3(sensor.alignedPosition, sensor.position)
    || !sameVector3(sensor.alignedRotation, sensor.rotation)
  );
